import Box from "@mui/material/Box";
import { ErrorBoundary } from "react-error-boundary";
import { Route, Routes } from "react-router";

import ErrorFallback from "../common/ErrorFallback";
import ProspectListContainer from "./prospect-list";

function ProspectContainer() {
  return (
    <Box
      data-testid="prospect-container"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
      }}
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Routes>
          <Route path="/*" element={<ProspectListContainer />} />
        </Routes>
      </ErrorBoundary>
    </Box>
  );
}

export default ProspectContainer;
